<template>
<div class="list-complete">
  <transition-group name="list-complete" tag="p">
    <div
      v-for="(pinnedQuestion, index) in questionsPinned"
      :key="'pinned' + pinnedQuestion.id"
    >
      <div :key="index" class="pinnedQuestion list-complete-item">
      <p class="date-publication">
        {{
          pinnedQuestion.created_at
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/') +
            ' - ' +
            pinnedQuestion.created_at
              .substring(10, 16)
        }}
      </p>
      <p class="date-publication">ref.{{pinnedQuestion.id}}</p>
        <p v-html="affiche_question(pinnedQuestion.question)"></p>
        <span v-if="pinnedQuestion.media">
          <span v-if="getExtension(pinnedQuestion.media, 'image')">
            <img :src="url_media + pinnedQuestion.media" class="img_jointe" />
          </span>
          <span v-if="getExtension(pinnedQuestion.media, 'video')">
            <video
              controls
              :src="url_media + pinnedQuestion.media"
              class="img_jointe"
            ></video>
          </span>
        </span>
      </div>
    </div>
    <div
      v-for="questionProjeter in questions"
      :key="'normal' + questionProjeter.id"
      class="list-complete-item"
    >
      <p class="date-publication">
        {{
          questionProjeter.created_at
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/') +
            ' - ' +
            questionProjeter.created_at
              .substring(10, 16)
        }}
      </p>
      <p class="date-publication">ref.{{questionProjeter.id}}</p>
      <p v-html="affiche_question(questionProjeter.question)"></p>
      <span v-if="questionProjeter.media">
        <span v-if="getExtension(questionProjeter.media, 'image')">
          <img :src="url_media + questionProjeter.media" class="img_jointe" />
        </span>
        <span v-if="getExtension(questionProjeter.media, 'video')">
          <video
            controls
            :src="url_media + questionProjeter.media"
            class="img_jointe"
          ></video>
        </span>
      </span>
    </div>
  </transition-group>
  <br><br><br>
  </div>

</template>

<script>
export default {
  props: {
    checkingUrlParticipant: Boolean,
    questions: Array,
    questionsPinned: Array
  },
  data () {
    return {
      url_media: process.env.URL_MEDIA
    }
  },
  methods: {
    getExtension (chemin, type_test) {
      var extensionsIMG = new Array('png', 'gif', 'jpg', 'jpeg')
      var extensionsVIDEO = new Array('mp4')
      var regex = /[^.]*$/i
      var resultats = chemin.match(regex)
      if (type_test == 'video' && extensionsVIDEO.indexOf(resultats[0]) != -1) {
        return 1
      }
      if (type_test == 'image' && extensionsIMG.indexOf(resultats[0]) != -1) {
        return 1
      }
      return 0
    },
    affiche_question (laQuestion) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
      if (laQuestion) {
        laQuestion = laQuestion.replace(urlRegex, function (url, b, c) {
          var url2 = c == 'www.' ? 'http://' + url : url
          return (
            '<a class="url_pinned" href="' +
            url2 +
            '" target="_blank">' +
            url +
            '</a>'
          )
        })
      }
      return laQuestion
    }
  }
}
</script>

<style>
.pinnedQuestion {
  padding: 30px;
  min-width: 50px;
  min-height: 50px;
  width: calc(100% - 20px);
  background: #dddbdc !important;
  font-size: 25px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
  opacity: 0.95;
}

.list-complete {
  height:64vh;
  overflow-y:auto;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin: 10px 0px 2px 10px;
  padding: 20px;
  min-width: 50px;
  min-height: 50px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
  background: white;
  opacity: 0.95;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.img_jointe {
  margin: 5px 5px 5px 0;
  max-width: 230px;
}
.date-publication {
  font-size: 10px;
  font-style: italic;
  color: #8a898e;
}
</style>



// WEBPACK FOOTER //
// src/components/Questionner/projectionQuestions.vue